import React from 'react';
import colours from 'theme/atoms/colours';

export const BAR_SIZE = 10;
const CURSOR_PADDING = 5;
const CURSOR_HEIGHT = BAR_SIZE + CURSOR_PADDING * 2;
const BAR_INSET = 5;

interface BarShapeProps {
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  fill?: string;
  value?: number;
}

export function BarShape({
  x = 0,
  y = 0,
  width = 0,
  height = 0,
  fill,
  value = 0,
}: BarShapeProps) {
  const minWidth = value > 0 ? BAR_SIZE : 0;

  return (
    <rect
      x={x + BAR_INSET}
      y={y}
      width={Math.max(minWidth, width - BAR_INSET * 2)}
      height={height}
      fill={fill}
      rx={BAR_SIZE / 2}
      ry={BAR_SIZE / 2}
    />
  );
}

interface CursorProps {
  x?: number;
  y?: number;
  width?: number;
  height?: number;
}

export function CustomCursor({
  x = 0,
  y = 0,
  width = 0,
  height = 0,
}: CursorProps) {
  const centerY = y + height / 2;

  return (
    <rect
      x={x}
      y={centerY - CURSOR_HEIGHT / 2}
      width={width}
      height={CURSOR_HEIGHT}
      fill={colours.neutral[100]}
      stroke={colours.neutral[200]}
      strokeWidth={1}
      rx={10}
      ry={10}
    />
  );
}
